Ext.define('SA.lq.view.ExportActivityFactory', {
    constructor({requestFactory, toolbarExportBtn, widgetFactory}) {
        this.requestFactory = requestFactory;
        this.toolbarExportBtn = toolbarExportBtn;
        this.widgetFactory = widgetFactory;
    },

    createActivity({state, onDone: onActivityDoneCb}) {
        var activityDone = false,
            widget = this.widgetFactory.createWidget(),
            requestFactory = this.requestFactory,
            menu = Ext.widget({
                xtype: 'arrow-menu',
                alignment: 'bottom',
                cls: 'sa-arrow-export-menu',
                items: [widget],
                target: this.toolbarExportBtn
            }),
            mouseHandler = new SA.lq.view.ExportDocMouseHandler({
                beyondLimitPopupPresent: false,
                isInMenu: ev => menu.el.dom.contains(ev.target),
                isInToolbarExportBtn: ev => this.toolbarExportBtn.el.dom.contains(ev.target)
            }),
            clickListener = SA.Html.addCapturingListener('click', ev => mouseHandler.onClick(ev)),
            mousedownListener = SA.Html.addCapturingListener('mousedown', ev => mouseHandler.onMousedown(ev)),
            destroyActivity = () => {
                activityDone = true;
                menu.destroy();
                clickListener.destroy();
                mousedownListener.destroy();
                onActivityDoneCb();
            };

        mouseHandler.setOutsideMenuClickCb(destroyActivity);

        widget.exportBtn.on('click', onExportBtnClick);
        widget.cancelBtn.on('click', destroyActivity);

        if (!state.getConditionList().hasConditions()) {
            widget.hideLoadMask();
            widget.enableFileFormatRadioGroup();
            widget.enableDeliveryTypeSwitch();
            widget.enableExportBtn();
            return;
        }

        requestFactory.createLimitCheckRequest(state).then(results => {
            if (activityDone) {
                return;
            }

            widget.hideLoadMask();

            if (results.some(datasetExportUsage => datasetExportUsage.proposedTotalUseExceedsLimits())) {
                let linkPopupTplData = getBeyondLimitPopupTplData(results);

                widget.setLimitMessageLinkClickCb(() => onLimitDetailLinkClick(linkPopupTplData));
                widget.showLimitMessage();
            }
            else if (results.length > 0) {
                widget.enableFileFormatRadioGroup();
                widget.enableDeliveryTypeSwitch();
                widget.enableExportBtn();
            }
        });

        function onExportBtnClick() {
            requestFactory.createExportRequest({
                state,
                deliveryType: widget.getDeliveryTypeSwitchValue(),
                fileExtension: widget.getFileFormatRadioGroupValue(),
                emailAddress: widget.getEmailAddressValue(),
                emailMessage: widget.getEmailMessageValue()
            });

            destroyActivity();
        }

        function onLimitDetailLinkClick(linkPopupTplData) {
            mouseHandler.setBeyondLimitPopupPresent(true);

            Ext.widget({
                xtype: 'beyond-limit-popup',
                data: linkPopupTplData,
                listeners: {destroy: () => mouseHandler.setBeyondLimitPopupPresent(false)}
            });
        }

        function getBeyondLimitPopupTplData(results) {
            var tplData = results
                .filter(datasetExportUsage => datasetExportUsage.proposedTotalUseExceedsLimits())
                .map(datasetExportUsage => {
                    var datasetName = datasetExportUsage.getDatasetName(),
                        weeklyUsage = datasetExportUsage.getWeeklyUsage(),
                        yearlyUsage = datasetExportUsage.getYearlyUsage(),
                        perWeek = {
                            usedPercent: weeklyUsage.getCurrentTotalUsePercent(),
                            wouldBeUsedPercent: weeklyUsage.getProposedTotalUsePercent()
                        },
                        perYear = {
                            usedPercent: yearlyUsage.getCurrentTotalUsePercent(),
                            wouldBeUsedPercent: yearlyUsage.getProposedTotalUsePercent()
                        };

                    return {datasetName, perWeek, perYear};
                });

            tplData.sort((a, b) => a.datasetName.localeCompare(b.datasetName));

            return tplData;
        }
    }
});